import {
  ATTACHMENT_TYPE_IMAGE,
  ATTACHMENT_TYPE_PDF,
  PROTOCOL_PATTERN,
  THUBOR_SIZE_IMAGE,
  THUBOR_SIZE_PDF,
  THUMBOR_TYPE_IMAGE,
  THUMBOR_TYPE_PDF,
  THUMBOR_URL
} from './thumbor';

export function getAttachmentsThumborURL(imageUrl, sizeOfImage, type) {
  if (typeof imageUrl === 'string') {
    imageUrl = imageUrl.trim();
  }

  if (imageUrl === '' || !imageUrl.match(PROTOCOL_PATTERN) || imageUrl.includes(THUMBOR_URL)) {
    return imageUrl;
  }

  sizeOfImage = typeof sizeOfImage !== 'undefined' ? sizeOfImage : '0x0';

  let attachmentType;

  switch (type) {
    case ATTACHMENT_TYPE_IMAGE:
      attachmentType = THUMBOR_TYPE_IMAGE;
      break;

    case ATTACHMENT_TYPE_PDF:
      attachmentType = THUMBOR_TYPE_PDF;
      break;

    default:
      attachmentType = THUMBOR_TYPE_IMAGE;
      break;
  }

  const resource = `${sizeOfImage}/${attachmentType}/${encodeURIComponent(imageUrl)}`;

  return `${THUMBOR_URL}unsafe/${resource}`;
}

export function getThumborSize(type) {
  return type === ATTACHMENT_TYPE_PDF ? THUBOR_SIZE_PDF : THUBOR_SIZE_IMAGE;
}
